import { useTranslation } from "react-i18next";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Consts } from "../../pages/consts";

const DrugInsertTypeRadioGroup = ({ enteringKind, handleEnteringKind }) => {
  const {
    t: t
  } = useTranslation();

  return (
    (<RadioGroup
      row
      aria-labelledby="upload-manual-group"
      name="upload-manual-group"
      value={enteringKind}
      defaultValue={enteringKind}
      onChange={handleEnteringKind}
    >
      <FormControlLabel
        value={Consts.UPLOAD}
        control={<Radio />}
        label={<label>{t("upload_file")}</label>}
      />
      <FormControlLabel
        value={Consts.MANUALLY}
        control={<Radio />}
        label={<label>{t("enter_manually")}</label>}
      />
    </RadioGroup>)
  );
};

export default DrugInsertTypeRadioGroup;
